<template>
  <div
    class="html_playerTable_AT"
    ref="html_playerTable_AT"
    v-if="datas.objectInfo && datas.objectInfo.length == 2"
  >
    <div class="main">
      <div class="left-box">
        <span class="left_title" v-if="homeObj.teamName && homeObj.teamScore">
          <span v-text="'总成绩：'"></span>
          <!-- <span v-text="'657.2'"></span> -->
          <NumberScrolling
            :tarVal="homeObj.teamScore"
            :unit="''"
          ></NumberScrolling>
        </span>
        <template v-if="themetype === 'A' && homeObj.teamName">
          <APlayerImg
            :key="homeObj.playerInfos[0].playerId"
            :playerImg="homeObj.playerInfos[0].profilePicture"
            :playerNum="homeObj.playerInfos[0].shirtNumber * 1"
            :playerName="homeObj.playerInfos[0].playerName"
            :countryImg="homeObj.teamLogo"
            :countryName="homeObj.teamName"
            :width="'9vw'"
          ></APlayerImg>
        </template>

        <template v-else-if="themetype === 'T' && homeObj.teamName">
          <DelegationImg
            :key="homeObj.teamId"
            :countryImg="homeObj.teamLogo"
            :countryName="homeObj.teamName"
            :width="'6vw'"
            :logoHeight="'4vw'"
          ></DelegationImg>
        </template>
      </div>
      <div class="table_box" :class="themetype">
        <!-- <span class="t_header">
          <span class="customTable_row">
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
              v-text="columnItem.name"
            ></span>
          </span>
        </span> -->
        <span class="t_body">
          <span class="customTable_row">
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
              v-text="columnItem.name"
            ></span>
          </span>
          <span
            class="customTable_row"
            v-for="(rowData, rowIndex) in datas.data.dataList"
            :key="rowIndex"
          >
            <span
              class="customTable_row_cell"
              v-for="columnItem in datas.statisticsModels"
              :key="columnItem.statisticalEn"
            >
              <NumberScrolling
                :tarVal="rowData[columnItem.statisticalEn]"
                :unit="columnItem.suffix"
              ></NumberScrolling>
            </span>
          </span>
        </span>
      </div>
      <div class="right-box">
        <span class="right_title" v-if="awayObj.teamName && awayObj.teamScore">
          <span v-text="'总成绩：'"></span>
          <!-- <span v-text="'657.2'"></span> -->
          <NumberScrolling
            :tarVal="awayObj.teamScore"
            :unit="''"
          ></NumberScrolling>
        </span>
        <template v-if="themetype === 'A' && awayObj.teamName">
          <APlayerImg
            :key="awayObj.playerInfos[0].playerId"
            :playerImg="awayObj.playerInfos[0].profilePicture"
            :playerNum="awayObj.playerInfos[0].shirtNumber * 1"
            :playerName="awayObj.playerInfos[0].playerName"
            :countryImg="awayObj.teamLogo"
            :countryName="awayObj.teamName"
            :width="'9vw'"
          ></APlayerImg>
        </template>

        <template v-else-if="themetype === 'T' && awayObj.teamName">
          <DelegationImg
            :key="awayObj.teamId"
            :countryImg="awayObj.teamLogo"
            :countryName="awayObj.teamName"
            :width="'6vw'"
            :logoHeight="'4vw'"
          ></DelegationImg>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
// 运动员数据 左右俩边对抗类 +中间表格  单人 ||  团体
import APlayerImg from '../components/PlayerImg'
import DelegationImg from '../components/DelegationImg'
import NumberScrolling from '../components/NumberScrolling'
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_playerTable_AT',
  // mixins: [htmlDomToImage_base64_data_mixin],
  components: {
    APlayerImg,
    DelegationImg,
    NumberScrolling,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {
          dataList: [],
        },
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {
      // themetype: 'A', //A:单人；D:双人；T:团队
      // sportType: 'uncombat', //combat: 对抗； uncombat:非对抗
    }
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    themetype() {
      let themeType = ''
      const len = this.datas.objectInfo[0].playerInfos.length
      if (len === 0) {
        themeType = 'T'
      } else if (len === 1) {
        themeType = 'A'
      } else if (len === 2) {
        themeType = 'D'
      }
      return themeType
    },
    sportType() {
      let sportType = ''
      const len = this.datas.data.dataList[0].showDataList.length
      if (len === 1) {
        sportType = 'uncombat'
      } else if (len === 2) {
        sportType = 'combat'
      }
      return sportType
    },
    homeObj() {
      return this.datas.objectInfo && this.datas.objectInfo.length > 0
        ? this.datas.objectInfo[0]
        : {}
    },
    awayObj() {
      return this.datas.objectInfo && this.datas.objectInfo.length === 2
        ? this.datas.objectInfo[1]
        : {}
    },
  },
  methods: {
    _valFormatHandler(val, text, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = ''
      } else {
        if (text) {
          data = `${text}: ${val}${ceil ? ceil : ''}`
        } else {
          data = val
        }
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_playerTable_AT {
  width: 100%;
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    width: 94%;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    color: var(--mixtmt_greyColor_main);

    .left-box {
      margin-right: 0.694vw;
      .left_title {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        padding-bottom: 0.694vw;
        color: var(--mixtmt_greyColor3);
        span {
          font-size: 0.972vw;
          line-height: 2.083vw;
        }
      }
    }
    .right-box {
      margin-left: 0.694vw;
      .right_title {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        padding-bottom: 0.694vw;
        color: var(--mixtmt_greyColor3);
        span {
          font-size: 0.972vw;
          line-height: 2.083vw;
        }
      }
    }
    .table_box {
      position: relative;
      height: auto;
      /* display: table; */
      display: block;
      padding-top: 2.083vw;
      &.A {
        width: calc(100% - 10vw);
      }
      &.D {
        width: calc(100% - 13.88vw);
      }
      &.T {
        width: calc(100% - 10vw);
      }
      /* .t_header {
        width: 100%;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 2;
        .customTable_row {
          display: table-row;
          height: 2.083vw;
          color: var(--mixtmt_greyColor4);
          width: 100%;
          background: linear-gradient(
            180deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          border-bottom: 0;
          .customTable_row_cell {
            font-size: 0.972vw;
            border-bottom: 0;
          }
        }
      } */
      .t_body {
        width: 100%;
        height: auto;
        /* display: table; */
        display: block;
        max-height: 15.62vw;
        overflow: auto;
      }

      .customTable_row {
        display: table-row;
        height: 2.083vw;
        color: var(--mixtmt_greyColor4);
        &:first-child {
          position: sticky;
          top: 0;
          right: 3%;
          z-index: 2;
          display: table-row;
          height: 2.083vw;
          color: var(--mixtmt_greyColor4);
          width: 100%;
          background: linear-gradient(
            180deg,
            var(--mixtmt_theme_defaultGradient_1_1) 0%,
            var(--mixtmt_theme_defaultGradient_1_2) 98%
          );
          color: var(--mixtmt_whiteColor);
          border-bottom: 0;
          .customTable_row_cell {
            font-size: 0.972vw;
            border-bottom: 0;
          }
        }
      }

      .customTable_row_cell {
        display: table-cell;
        padding: 0.486vw 0;
        font-size: 0.833vw;
        line-height: 1.11vw;
        font-weight: bold;
        text-align: center;
        width: 5%;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        vertical-align: middle;
      }
    }
  }
}
</style>
